module.exports = __webpack_public_path__ + "static/media/wide.6340e988.jpg";